import _Reflect$construct from "@babel/runtime-corejs3/core-js-stable/reflect/construct";
import _classCallCheck from "@babel/runtime-corejs3/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs3/helpers/createClass";
import _assertThisInitialized from "@babel/runtime-corejs3/helpers/assertThisInitialized";
import _inherits from "@babel/runtime-corejs3/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime-corejs3/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs3/helpers/getPrototypeOf";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { noop } from 'lodash';
import EditModal from '../../common/modal/EditModal';
import EditEmailAddresses from './EditEmailAddresses';
import { primaryFirstEmailSort } from './EditEmailAddresses/utils';
import Email from './Email';
import RowDisplay from '../../common/RowDisplay';
export var EmailAddresses = /*#__PURE__*/function (_Component) {
  _inherits(EmailAddresses, _Component);
  var _super = _createSuper(EmailAddresses);
  function EmailAddresses(props) {
    var _this;
    _classCallCheck(this, EmailAddresses);
    _this = _super.call(this, props);
    _this.state = {
      emailDisplay: []
    };
    _this.setEmailDisplay = _this.setEmailDisplay.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(EmailAddresses, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setEmailDisplay(this.props.emails);
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if (this.props.emails !== nextProps.emails) {
        this.setEmailDisplay(nextProps.emails);
      }
    }
  }, {
    key: "setEmailDisplay",
    value: function setEmailDisplay() {
      var _context;
      var emails = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var emailDisplay = _mapInstanceProperty(_context = primaryFirstEmailSort(emails)).call(_context, function (email, index) {
        var _context2;
        return /*#__PURE__*/React.createElement("div", {
          className: "col-sm-6 mb-two",
          key: _concatInstanceProperty(_context2 = "".concat(email.id, "-")).call(_context2, index)
        }, /*#__PURE__*/React.createElement(Email, {
          item: email
        }));
      });
      this.setState({
        emailDisplay: emailDisplay
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        updateGroup = _this$props.updateGroup,
        emails = _this$props.emails,
        onSave = _this$props.onSave;
      var editSection = /*#__PURE__*/React.createElement(EditModal, {
        header: "Edit Email",
        formName: "edit-email-addresses",
        editButtonId: "edit-email-btn",
        id: "edit-email-modal"
      }, /*#__PURE__*/React.createElement(EditEmailAddresses, {
        updateGroup: updateGroup,
        emails: emails,
        onSave: onSave
      }));
      return /*#__PURE__*/React.createElement(RowDisplay, {
        className: "email-addresses",
        editSection: editSection,
        label: "Email"
      }, this.state.emailDisplay);
    }
  }]);
  return EmailAddresses;
}(Component);
EmailAddresses.propTypes = {
  emails: PropTypes.array,
  onSave: PropTypes.func
};
EmailAddresses.defaultProps = {
  emails: [],
  onSave: noop
};
export default EmailAddresses;
//# sourceMappingURL=index.js.map